import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { QuickBooksConfigurationFormValues } from '../QuickBooksConfigurationFormSchema';
import { QuickBooksIntegrationConfiguration } from '@vy/integrations-types';
import { SYNC_DIRECTIONS } from '../QuickBooksConfigurationFormSchema';
import { nullToUndefined } from '@vy/null';

export function getQuickBooksIntegrationSettings(configuration: QuickBooksConfigurationFormValues) {
  return {
    integrationProvider: INTEGRATION_PROVIDERS.quickBooks,
    integrationConfiguration: mapFormValuesToQuickBooksSettings(configuration),
  };
}

function mapFormValuesToQuickBooksSettings(
  formValues: QuickBooksConfigurationFormValues,
): DeepPartial<QuickBooksIntegrationConfiguration> {
  const autoImportCustomers = formValues.syncCustomer === SYNC_DIRECTIONS.SYNC_TO_VAYU;
  const autoExportInvoices = formValues.syncApprovedInvoices;

  const defaultStripeDepositToAccountId = nullToUndefined(formValues.defaultStripeDepositToAccountId);
  const defaultDepositToAccountId = nullToUndefined(formValues.defaultDepositToAccountId);

  return {
    generalConfig: {
      autoImportCustomers,
      autoExportInvoices,
      autoExportCreditMemos: formValues.autoExportCreditMemos,
      invoiceNumberSyncStrategy: formValues.invoiceNumberSyncStrategy,
      invoicePaymentStatusSyncStrategy: formValues.invoicePaymentStatusSyncStrategy,
      exportBankDetails: formValues.exportBankDetails,
      defaultStripeDepositToAccountId,
      defaultDepositToAccountId,
      taxExportStrategy: formValues.taxExportStrategy,
      accountTaxItem: formValues.accountTaxItem,
    },
  };
}
